import React from 'react';

// Location pages
import LocationsHub from '../pages/locations/LocationsHub';
import Weyburn from '../pages/locations/Weyburn';
import Regina from '../pages/locations/Regina';
import Lloydminster from '../pages/locations/Lloydminster';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

export const locationRoutes: RouteConfig[] = [
  {
    path: "/locations",
    element: <LocationsHub />,
  },
  {
    path: "/locations/weyburn",
    element: <Weyburn />,
  },
  {
    path: "/locations/regina",
    element: <Regina />,
  },
  {
    path: "/locations/lloydminster",
    element: <Lloydminster />,
  },
];
